import React from 'react';
import { Input } from 'reactstrap';
import './CustomInput.scss';

const CustomInput = ({ id, label, type = "text", placeholder, value, onChange, ...props }) => {
  return (
    <>
      <Input
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="custom-input"
        {...props}
      />
    </>
  );
};

export default CustomInput;